import { useContext } from 'react';
import HistoryContext, { HistoryContextType } from './HistoryContext';

export default (): HistoryContextType => useContext<HistoryContextType>(HistoryContext);
